<mat-form-field appearance="outline" class="full-width date-cell">
  <input
    matInput
    [matDatepicker]="picker"
    [attr.aria-label]="labelKey() | translate | capitalize"
    [disabled]="disabled()"
    [value]="dateValue()"
    (dateChange)="dateChange.emit($event.value)" />
  @if (saveState() === 'saving') {
    <mat-hint align="start" class="hint">
      <mat-spinner class="custom-spinner"></mat-spinner>
      <span>{{ 'general.actions.saving' | translate }}</span>
    </mat-hint>
  } @else if (saveState() === 'saved') {
    <mat-hint align="start" class="hint saved-hint">
      <mat-icon inline>done</mat-icon>
      <span>{{ 'general.words.saved' | translate }}</span>
    </mat-hint>
  } @else {
    <mat-hint align="start" class="hint"></mat-hint>
  }
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
